/**
 * ZÉN-TRA Luxury Shopify Theme — JavaScript
 * Version: 1.0.0
 */

(function () {
  'use strict';

  /* ── CART STATE ── */
  const CartAPI = {
    async get() {
      const res = await fetch('/cart.js');
      return res.json();
    },
    async add(variantId, quantity = 1) {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity }),
      });
      return res.json();
    },
    async update(updates) {
      const res = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates }),
      });
      return res.json();
    },
    async change(key, quantity) {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity }),
      });
      return res.json();
    },
  };

  /* ── CART DRAWER ── */
  const cartDrawer = document.getElementById('cart-drawer');
  const cartOverlay = document.getElementById('cart-drawer-overlay');
  const cartClose = document.getElementById('cart-drawer-close');
  const cartToggleBtns = document.querySelectorAll('[data-cart-toggle]');

  function openCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    if (cartOverlay) {
      cartOverlay.classList.add('open');
      cartOverlay.setAttribute('aria-hidden', 'false');
    }
    document.body.style.overflow = 'hidden';
  }

  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    if (cartOverlay) {
      cartOverlay.classList.remove('open');
      cartOverlay.setAttribute('aria-hidden', 'true');
    }
    document.body.style.overflow = '';
  }

  cartToggleBtns.forEach(btn => btn.addEventListener('click', openCartDrawer));
  if (cartClose) cartClose.addEventListener('click', closeCartDrawer);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCartDrawer);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeCartDrawer();
  });

  /* ── UPDATE CART COUNT ── */
  function updateCartCount(count) {
    const countEl = document.getElementById('cart-count');
    if (!countEl) return;
    countEl.textContent = count;
    countEl.style.display = count > 0 ? 'flex' : 'none';
    const drawerCount = document.getElementById('drawer-item-count');
    if (drawerCount) drawerCount.textContent = count;
  }

  function updateCartSubtotal(total) {
    const money = formatMoney(total);
    const subtotalEl = document.getElementById('cart-subtotal');
    const drawerSubtotal = document.getElementById('drawer-subtotal');
    if (subtotalEl) subtotalEl.textContent = money;
    if (drawerSubtotal) drawerSubtotal.textContent = money;
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  /* ── QUICK ADD TO CART ── */
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('.btn-quick-add');
    if (!btn || btn.disabled) return;

    const variantId = btn.dataset.variantId;
    if (!variantId) return;

    const originalText = btn.textContent;
    btn.textContent = 'Adding...';
    btn.disabled = true;

    try {
      await CartAPI.add(variantId, 1);
      const cart = await CartAPI.get();
      updateCartCount(cart.item_count);
      updateCartSubtotal(cart.total_price);
      btn.textContent = 'Added ✓';
      setTimeout(() => {
        btn.textContent = originalText;
        btn.disabled = false;
      }, 1500);
      openCartDrawer();
    } catch (err) {
      console.error('Add to cart error:', err);
      btn.textContent = 'Error';
      setTimeout(() => {
        btn.textContent = originalText;
        btn.disabled = false;
      }, 1500);
    }
  });

  /* ── PRODUCT FORM (product page) ── */
  const productForm = document.getElementById('product-form');
  if (productForm) {
    productForm.addEventListener('submit', async (e) => {
      e.preventDefault();

      const variantInput = document.getElementById('variant-id');
      const quantityInput = document.getElementById('quantity');
      const addBtn = productForm.querySelector('[data-add-to-cart]');
      const addBtnText = productForm.querySelector('[data-add-to-cart-text]');

      if (!variantInput) return;

      const variantId = variantInput.value;
      const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;

      if (addBtnText) addBtnText.textContent = 'Adding...';
      if (addBtn) addBtn.disabled = true;

      try {
        await CartAPI.add(variantId, quantity);
        const cart = await CartAPI.get();
        updateCartCount(cart.item_count);
        updateCartSubtotal(cart.total_price);
        if (addBtnText) addBtnText.textContent = 'Added to Cart ✓';
        setTimeout(() => {
          if (addBtnText) addBtnText.textContent = 'Add to Cart';
          if (addBtn) addBtn.disabled = false;
        }, 2000);
        openCartDrawer();
      } catch (err) {
        console.error('Add to cart error:', err);
        if (addBtnText) addBtnText.textContent = 'Error — Try Again';
        if (addBtn) addBtn.disabled = false;
      }
    });
  }

  /* ── VARIANT SELECTOR (product page) ── */
  const variantBtns = document.querySelectorAll('.variant-btn');
  variantBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      const option = btn.dataset.option;
      document.querySelectorAll(`.variant-btn[data-option="${option}"]`).forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      updateSelectedVariant();
    });
  });

  function updateSelectedVariant() {
    // Shopify variant matching — simplified
    const selectedOptions = {};
    document.querySelectorAll('.variant-btn.active').forEach(btn => {
      selectedOptions[btn.dataset.option] = btn.dataset.value;
    });
    // In a real theme, you'd match against window.productVariants
    // For now, we just keep the first available variant
  }

  /* ── QUANTITY CONTROLS ── */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.qty-btn');
    if (!btn) return;

    const action = btn.dataset.action;
    const key = btn.dataset.key;

    // Cart page / drawer quantity update
    if (key) {
      const qtyInput = document.querySelector(`.cart-qty-input[data-key="${key}"]`);
      const qtyDisplay = btn.closest('.quantity-control')?.querySelector('.qty-display');

      if (qtyInput) {
        let val = parseInt(qtyInput.value) || 0;
        if (action === 'increase') val++;
        else if (action === 'decrease') val = Math.max(0, val - 1);
        qtyInput.value = val;
        updateCartItemQuantity(key, val);
      } else if (qtyDisplay) {
        let val = parseInt(qtyDisplay.textContent) || 0;
        if (action === 'increase') val++;
        else if (action === 'decrease') val = Math.max(0, val - 1);
        qtyDisplay.textContent = val;
        updateCartItemQuantity(key, val);
      }
      return;
    }

    // Product page quantity
    const qtyInput = document.getElementById('quantity');
    if (qtyInput) {
      let val = parseInt(qtyInput.value) || 1;
      if (action === 'increase') val++;
      else if (action === 'decrease') val = Math.max(1, val - 1);
      qtyInput.value = val;
    }
  });

  async function updateCartItemQuantity(key, quantity) {
    try {
      const cart = await CartAPI.change(key, quantity);
      updateCartCount(cart.item_count);
      updateCartSubtotal(cart.total_price);
      if (quantity === 0) {
        const item = document.querySelector(`[data-key="${key}"]`);
        if (item) item.remove();
      }
    } catch (err) {
      console.error('Cart update error:', err);
    }
  }

  /* ── REMOVE CART ITEM ── */
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('.cart-remove-btn');
    if (!btn) return;

    const key = btn.dataset.key;
    if (!key) return;

    try {
      const cart = await CartAPI.change(key, 0);
      updateCartCount(cart.item_count);
      updateCartSubtotal(cart.total_price);
      const item = document.querySelector(`.cart-item[data-key="${key}"]`);
      if (item) item.remove();
      const drawerItem = document.querySelector(`.drawer-item[data-key="${key}"]`);
      if (drawerItem) drawerItem.remove();
    } catch (err) {
      console.error('Remove item error:', err);
    }
  });

  /* ── PRODUCT GALLERY THUMBNAILS ── */
  const thumbBtns = document.querySelectorAll('.thumb-btn');
  const mainImage = document.getElementById('product-main-image');

  thumbBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      thumbBtns.forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      if (mainImage && btn.dataset.src) {
        mainImage.src = btn.dataset.src;
      }
    });
  });

  /* ── MOBILE MENU ── */
  const mobileToggle = document.getElementById('mobile-menu-toggle');
  const mobileNav = document.getElementById('mobile-nav');

  if (mobileToggle && mobileNav) {
    mobileToggle.addEventListener('click', () => {
      const isOpen = mobileNav.classList.toggle('open');
      mobileToggle.classList.toggle('open', isOpen);
      mobileToggle.setAttribute('aria-expanded', isOpen.toString());
      mobileNav.setAttribute('aria-hidden', (!isOpen).toString());
    });
  }

  /* ── SCROLL REVEAL (lightweight) ── */
  if ('IntersectionObserver' in window) {
    const revealEls = document.querySelectorAll('.product-card, .edition-card, .testimonial-card, .trust-item');
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    revealEls.forEach(el => {
      el.style.opacity = '0';
      el.style.transform = 'translateY(20px)';
      el.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
      observer.observe(el);
    });
  }

  /* ── INIT ── */
  CartAPI.get().then(cart => {
    updateCartCount(cart.item_count);
    updateCartSubtotal(cart.total_price);
  }).catch(() => {});

})();
